import React, { useEffect, useContext } from "react";
import TraitList from "../TraitList/TraitList";
import "../../../Utils/CSS/cards.css";
import { QuestionContext } from "../../../Utils/contexts/QuestionContext";
import Preloader from "../../General/Preloader/Preloader";

const QuestionComponentParent = () => {

  const {
    fetchTraits,
    isLoaded, setIsLoaded,
  } = useContext(QuestionContext);


  useEffect(() => {
    setIsLoaded(false);
    const fetcher = async () => {
      await Promise.all([fetchTraits()]);
      setIsLoaded(true);
    };
    fetcher();
  }, []);

  return (

    <div>
      <div className="Q-Item-list-container Q-item-list-min-width">
        <div>
          {(!isLoaded) ? <Preloader size="large"/> : <TraitList />}
        </div>
      </div>
    </div>
  );
};

export default QuestionComponentParent;
